import { useFetch } from './useFetch';

export function useGetAnalysisText(analysisId: string) {
  const { data, ...state } = useFetch<string>(`/data/analyses/${analysisId}.html`);

  return { ...state, text: data };
}
